export default __webpack_public_path__ + "static/media/42FCD319-067A-435B-A1BA-F4467C488D07_1_105_c.e2d82215.jpeg";